import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  TemplateRef,
} from '@angular/core';

@Directive({
    selector: '[luiBreadcrumbsItem]',
    standalone: false
})
export class BreadcrumbsItemDirective {
  constructor(public template: TemplateRef<BreadcrumbsItemDirective>) {}
}
